import React, { useState } from "react";
import { addChildToLucket, getSpreadsheetData, handleLucketDelete, updateBucket, updateValues } from "../slice/functions";
import { useDispatch, useSelector } from "react-redux";
import { selectBuckets, selectSpreadsheetID, selectTimeFrame, setBucketList } from "../slice/buckets";
import LucketStatusIcon from "./lucketStatusIcon/LucketStatusIcon.cmp";
import LucketActionStatusIcon from "./lucketActionStatusIcon/LucketActionStatusIcon.cmp";
import LucketTime from "./LucketTime";
import LucketCategory from "./lucketCategory/lucketCategory.cmp";
import Draggable from "react-draggable";
//import { createTodoThunk, updateTodo } from "../../todo/slice/functions";
import LucketIcons from "./LucketIcons";
import LucketIcon from "./LucketIcon";
//import { selectTodos } from "../../todo/slice/todo";
import { LucketEditText } from "./LucketEditText/LucketEditText.cmp";
import { AddBucket } from "../AddBucket.cmp";
import "./index.css"
import LucketWeekActionStatusIcon from "./lucketWeekActionStatusIcon/LucketWeekActionStatusIcon.cmp";
import { BUCKETLIST_CONTAINER_BACKGROUND_COLOR, LUCKET_DETAILS_BACKGROUND_COLOR, STATUS_OPTION, STATUS_OPTION_HEX_PALLETE, TIMEFRAME } from "../constants";
import { Paper, TextField, Tooltip } from "@mui/material";
import ConfirmationModal from "./deleteLucketModal";
import DeleteIcon from '@mui/icons-material/Delete';
import HelpIcon from '@mui/icons-material/QuestionMark';
import AddIcon from '@mui/icons-material/Add';

export function LucketItem({ lucket, childLuckets, planView, childLucket, countWeekDonePoints, isExpanded, isExpandedChild }) {
  const dispatch = useDispatch()
  const spreadsheetId = useSelector(selectSpreadsheetID);
  const timeFrame = useSelector(selectTimeFrame);
  //const todos = useSelector(selectTodos);
  const buckets = useSelector(selectBuckets)
  const [editDescription, setEditDescription] = useState(false)
  const [editTitle, setEditTitle] = useState(false)
  const [editingIcon, setEditIcon] = useState(false)
  const [addingChild, setAddingChild] = useState(false)

  const [openModal, setOpenModal] = useState(false);

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  // Function to close the modal
  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleConfirmDelete = async () => {

    let result = await handleLucketDelete(lucket)
    console.log(result, "result123")
    dispatch(setBucketList(result.data));
    setOpenModal(false); // Close the modal

  };
  function updateLucket(v, name) {
    let newBucket = updateValues(lucket, name, v);

    updateBucket(newBucket, dispatch, buckets)
  }

  async function addChildLucket() {
    let result = await addChildToLucket(lucket, childLuckets, buckets)
    dispatch(setBucketList(result.data));
  }
  // function checkIfAdded(rowID){
  //   //check all todos for this lucket

  //   let isAlreadyAdded =  todos.reduce((acc,v,i,ar)=>{
  //     if(v.lucket.rowID == rowID) return v
  //     else return acc
  //   },false)

  //   return isAlreadyAdded
  // }
  // function handleOnStop(a,b,c){
  //   let alreadyAdded = checkIfAdded(lucket.rowID);
  //   if(!alreadyAdded){

  //     let lucketTodoID = dispatch(createTodoThunk(lucket.name,childLuckets))
  //     dispatch(updateTodo({id:lucketTodoID,update:{
  //       lucket:lucket
  //     }}))
  //   }
  // }
  function handleEditDescription() {
    setEditDescription(!editDescription)
  }
  function cutDescription() {
    let newLength = 40
    let addition = ""
    if (lucket.description.split('\n')[0].substring(0, newLength) !== lucket.description.split('\n')[0]) {
      addition = "..."
    }
    return lucket.description.split('\n')[0].substring(0, newLength) + addition
  }
  function calculateBorderColor() {
    let calculatedBorderColor = lucket.status
    return calculatedBorderColor
  }

  function calculateTextColor(backgroundColor) {
    const color = backgroundColor.toLowerCase();
    if (color === STATUS_OPTION.Black || color === STATUS_OPTION.Blue || color === STATUS_OPTION.Green || color === STATUS_OPTION.Purple || color === STATUS_OPTION.Red) {
      return "white";
    }
    return "black";
  }

  return <div id={"lucketitemcontainer" + lucket.rowID} className="lucketItemParent">
    <Paper id={"lucketItem" + lucket.rowID} className="lucketItem" style={{ marginRight: !isExpandedChild && (!childLuckets || childLuckets.length === 0) ? "30px" : "0" }}>
      <div id={"lucketItemDetails" + lucket.rowID} className="lucketItemDetails" style={{ display: 'flex', flexDirection: 'row', marginBottom: !(editDescription || editTitle || editingIcon) && "50px" }}>


        <LucketStatusIcon status={lucket.status} lucket={lucket} updateLucket={updateLucket} />
        <LucketStatusIcon difficulty status={lucket.difficulty} lucket={lucket} updateLucket={updateLucket} />

        <div id={"lucketMainDetails" + lucket.rowID} className="lucketMainDetails" style={{ display: 'flex', flex: 2, flexDirection: 'row', backgroundColor: LUCKET_DETAILS_BACKGROUND_COLOR, width: "100%" }}>
          <LucketCategory lucket={lucket} planView={planView} updateLucket={updateLucket} />
          <LucketIcon
            icon={lucket.icon}
            lucket={lucket}
            editingIcon={editingIcon}
            setEditing={setEditIcon}
          />

          {(timeFrame == TIMEFRAME.All || timeFrame == TIMEFRAME.Day) && <div style={{ display: 'flex', flexDirection: 'column' }}>
            <LucketActionStatusIcon timeFrame={timeFrame} status="green" lucket={lucket} updateLucket={updateLucket} />
          </div>}
          {(timeFrame == TIMEFRAME.All || timeFrame == TIMEFRAME.Week) && <div style={{ display: 'flex', flexDirection: 'column' }}>
            <LucketWeekActionStatusIcon timeFrame={timeFrame} countWeekDonePoints={countWeekDonePoints} status="green" lucket={lucket} updateLucket={updateLucket} />
          </div>}
          {(timeFrame == TIMEFRAME.All || timeFrame == TIMEFRAME.Day) && <div className="lucketTimeContainer" style={{
            marginLeft: '15px',
            marginRight: '15px'
          }}>
            <LucketTime status={lucket.actionStatus}
              lucket={lucket} updateLucket={updateLucket} />
          </div>}
          <div style={{ display: 'flex', flexDirection: 'row', flex: 1 }}>
            <div id={"lucketName" + lucket.rowID} className="lucketName"
              onClick={() => setEditTitle(!editTitle)}
              title={lucket.name}>

              <span style={{ fontSize: lucket.fontSizeAndStyle?.fontSize, fontWeight: lucket.fontSizeAndStyle?.bold && "bold", fontStyle: lucket.fontSizeAndStyle?.italics && "italic" }}>
                {lucket.name} </span>
              {lucket._needsSync && (
                <Tooltip title="Offline changes - will sync when online">
                  <span className="offline-bucket-indicator"></span>
                </Tooltip>
              )}
            </div>

            {/* <div style={{ display: 'flex', flexDirection: 'column', margin: 15 }}>
          <input type='number' defaultValue={lucket[1]} onChange={async (e) => {
            updateLucket(e.target.value, "order")
          }} />
          <h1>{lucket.order}</h1>
        </div> */}
            {!isExpandedChild && (childLuckets && childLuckets.length > 0) ? (
              <div className="childrenSimpleShowcase">
                {
                  childLuckets.map((child, index) => (
                    <div key={index} style={{ display: 'flex', alignItems: 'center' }}>
                      <span className="childNameTag" title={child.name}>{child.name}</span>
                      <div className="childActionTag" title={`${timeFrame === TIMEFRAME.Week ? 'Week' : 'Day'} action points & status for: ${child.name}`} style={{ width: '20px', height: '20px', backgroundColor: timeFrame === TIMEFRAME.Week ? STATUS_OPTION_HEX_PALLETE[child.weekActionStatus] : STATUS_OPTION_HEX_PALLETE[child.actionStatus], marginLeft: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: calculateTextColor(timeFrame === TIMEFRAME.Week ? child.weekActionStatus : child.actionStatus), fontSize: '0.8em', borderStyle: 'solid', borderColor: 'white', borderWidth: '1px' }}>
                        {timeFrame === TIMEFRAME.Week ? child.weekPoints : child.points}
                      </div>
                    </div>
                  ))
                }
              </div>
            ) : (
              <div className='descriptionLucketItem' onClick={() => {
                handleEditDescription()
              }} style={{ display: 'flex', flexDirection: 'column', margin: '15px 15px 15px 0px', flex: 5 }}>
                <TextField variant="standard" value={cutDescription()} />
              </div>
            )}
          </div>


          <div style={{ display: 'flex', flexDirection: 'column', marginRight: '10px' }}>
            {!(childLuckets && childLuckets.length > 0) && !childLucket &&
              <Tooltip placement="left" title="Add Child">
                <div className="addChild hoverable" >
                  <AddIcon style={{ width: '20px', height: '20px', margin: 'auto' }} onClick={() => addChildLucket()} />
                </div>
              </Tooltip>}

            {(childLuckets && childLuckets.length > 0) && <div title={lucket.description} className="descriptionReplacementIcon">
              <HelpIcon onClick={() => {
                handleEditDescription()
              }} style={{ width: '20px', height: '20px', margin: 'auto' }} />
            </div>}

            <Tooltip placement="left" title="Delete Bucket">
              <DeleteIcon onClick={handleOpenModal} style={{ width: '20px', height: '20px', margin: 'auto' }} />
            </Tooltip>
            {isExpandedChild && <Tooltip placement="left" title="Show Description"><div className="questionMarkDescriptionIcon">
              <img src={"/images/questionSolid.png"} onClick={handleEditDescription} style={{ width: '20px', height: '20px', margin: 'auto' }} />
            </div></Tooltip>}

          </div>

        </div>
      </div>
      <ConfirmationModal
        open={openModal}
        onClose={handleCloseModal}
        onConfirm={_ => {

          handleConfirmDelete()
        }}
        title="Delete Item"
        message="Are you sure you want to delete this item? This action cannot be undone."
        confirmText="Delete"
        cancelText="Cancel"
      />
      <LucketEditText editIcon={editingIcon} luckets={buckets} isExpanded={isExpanded} editDescription={editDescription} editTitle={editTitle} lucket={lucket} updateLucket={updateLucket} addingChild={addingChild} />

      {editingIcon && <LucketIcons updateLucket={updateLucket}
        lucket={lucket}
        setEditing={setEditIcon}
      />}

    </Paper>
  </div>
}